<template>
    <div>
        <text-loading-placeholder v-if="isLoading" />
        <template v-else>
            <slot :name="slotName" />
        </template>
    </div>
</template>

<script>
    import './SlotCell.scss';
    import {AppResource} from  '@sellers-shield-home-protection/ss-core-js';
    import TableCellsMixin from "../../Mixins/TableCellsMixin";

    export default {
        name: 'SlotCell',

        mixins: [TableCellsMixin],

        props: {
            slotName: {
                type: String,
                required: true
            },
            appResource: {
                type: AppResource,
                required: false,
            },
            isLoading: {
                type: Boolean,
                default: false,
                required: false,
            },
        },
    };
</script>
